import crypto from 'crypto-js';

/**
 * Generate HMAC signature for API requests
 * @param method HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param path API path (e.g., /api/courses)
 * @param body Request body (null for GET requests)
 * @param timestamp Request timestamp in milliseconds
 * @param secret HMAC secret key
 * @returns HMAC signature as hex string
 */
export function generateHmacSignature(
  method: string,
  path: string,
  body: any,
  timestamp: string,
  secret: string,
): string {
  // Convert body to JSON string (or empty string if no body).
  // Must mirror the backend canonicalization in commodity/middleware/hmac.middleware.ts:
  // empty objects (`{}`) are treated as no body so backend's
  // `Object.keys(req.body).length > 0` check matches the frontend signature.
  const bodyString =
    body && (typeof body !== 'object' || Object.keys(body).length > 0) ? JSON.stringify(body) : '';

  // Create message in format: METHOD:PATH:BODY:TIMESTAMP
  const message = `${method}:${path}:${bodyString}:${timestamp}`;

  // Generate HMAC SHA-256 signature
  const signature = crypto.HmacSHA256(message, secret).toString();

  return signature;
}

/**
 * Get current timestamp in milliseconds
 */
export function getTimestamp(): string {
  return Date.now().toString();
}
